(function () {
  if (window.__jklCartCheckoutDiscountInit) return;
  window.__jklCartCheckoutDiscountInit = true;

  var root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    "/";
  var checkoutBase = root.replace(/\/$/, "") + "/checkout";

  function getTypedDiscountCode(form) {
    // Check the submitted form first (cart page: input is inside the form)
    var inForm = form.querySelector(
      'cart-discount-field input[name="discount"]',
    );
    if (inForm && inForm.value.trim()) return inForm.value.trim();

    // Fallback: scan all discount inputs for a non-empty value (drawer: input is outside form)
    var inputs = document.querySelectorAll(
      'cart-discount-field input[name="discount"]',
    );
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value.trim()) return inputs[i].value.trim();
    }
    return "";
  }

  // Cart API returns applicable:false for gift cards (not supported on cart, only checkout).
  // Before CartDiscountBanner makes itself visible, swap the generic error text with the
  // localized hint rendered by Liquid into data-gift-card-hint on cart-discount-banner.
  // This listener fires first because this script loads before theme.js in document order.
  document.addEventListener("cart:discount:error", function () {
    var hasTyped = false;
    var inputs = document.querySelectorAll(
      'cart-discount-field input[name="discount"]',
    );
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value.trim()) {
        hasTyped = true;
        break;
      }
    }
    if (!hasTyped) return;
    document
      .querySelectorAll("cart-discount-banner")
      .forEach(function (banner) {
        var hint = banner.dataset.giftCardHint;
        if (!hint) return;
        var p = banner.querySelector("p");
        if (p) p.textContent = hint;
      });
  });

  document.addEventListener(
    "submit",
    function (e) {
      var submitter = e.submitter;
      if (!submitter || submitter.name !== "checkout") return;

      e.preventDefault();

      var typedCode = getTypedDiscountCode(e.target);

      fetch(root + "cart.js")
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var codes = (cart.discount_codes || [])
            .filter(function (d) {
              return d.applicable;
            })
            .map(function (d) {
              return d.code;
            });

          // Include typed code (e.g. gift card that Cart API rejects) if not already present
          if (typedCode) {
            var lowerTyped = typedCode.toLowerCase();
            if (
              !codes.some(function (c) {
                return c.toLowerCase() === lowerTyped;
              })
            ) {
              codes.push(typedCode);
            }
          }

          var url = checkoutBase;
          if (codes.length > 0) {
            url += "?discount=" + encodeURIComponent(codes.join(","));
          }
          window.location.href = url;
        })
        .catch(function () {
          var url = typedCode
            ? checkoutBase + "?discount=" + encodeURIComponent(typedCode)
            : checkoutBase;
          window.location.href = url;
        });
    },
    true,
  );
})();
